import { connect } from 'react-redux'
import { setFilterText, toggleFilter, clearFilter } from '../actions/filter'
import { fetchPosts } from '../actions/posts'
import FilterBar from '../components/filter-bar'
import { pushStateChange } from '../history'

const mapStateToProps = state => ({
	filterOptions: state.filterOptions,
	filter: state.filter,
	isLoading: state.posts.isLoading
})

const mapDispatchToProps = (dispatch) => {
	let setFilterTextDelay = 400; //ms
	let filterTextTimeout = null;

	return {
		onInputChange: e => {
			let text = e.target.value;

			clearTimeout(filterTextTimeout);
			filterTextTimeout = setTimeout(() => {
				dispatch(setFilterText(text))
				dispatch(fetchPosts())
				dispatch(function(dispatch, getState){
					return pushStateChange(dispatch, getState);
				})
			}, setFilterTextDelay);
		},
		onClickDropdownOption: (name, option) => {
			dispatch(toggleFilter(name, option))
			dispatch(fetchPosts())
			dispatch(function(dispatch, getState){
				return pushStateChange(dispatch, getState);
			})
		},
		clearFilter: () => {
			dispatch(clearFilter())
			dispatch(fetchPosts())
			dispatch(pushStateChange(dispatch))
			dispatch(function(dispatch, getState){
				return pushStateChange(dispatch, getState);
			})
		}
	}
}

const FilterBarContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FilterBar)

export default FilterBarContainer
